import { render } from "./cloudflare_image_section.vue?vue&type=template&id=b8c42c8e&scoped=true"
import script from "./cloudflare_image_section.vue?vue&type=script&lang=js"
export * from "./cloudflare_image_section.vue?vue&type=script&lang=js"

import "./cloudflare_image_section.vue?vue&type=style&index=0&id=b8c42c8e&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c42c8e"]])

export default __exports__